import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import { Button } from "../Button/Button";
import { LinkCustom } from "../../navigation/LinkCustom/LinkCustom";

import "./ButtonIcon.scss";

export const ButtonIcon = ({
    className,
    children,
    href,
    isNavLink,
    type="button",
    warning,
    noWrap,
    info,
    success,
    error,
    ...restProps
}) => {
    const classnames = classNames(
        "button-icon",
        { "button-icon--warning": warning },
        { "button-icon--info": info },
        { "button-icon--success": success },
        { "button-icon--error": error },
        { "button-icon--no-wrap": noWrap },
        className
    );

    let props = {
        type,
        className: classnames,
        ...restProps
    };

    if(href) {
        props = {
            ...props,
            href,
            target: "_blank"
        };
    }

    const Tag = isNavLink ? NavLink : href ? LinkCustom : Button;

    return (
        <Tag {...props}>
            {children}
        </Tag>
    );
};

ButtonIcon.defaultProps = {
    className: null,
    children: null,
    warning: false
};

ButtonIcon.propTypes = {
    warning: PropTypes.bool,
    info: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node.isRequired
};
